import { ActionType } from '../constants/ActionTypes'
import { Auth } from '../services/Auth'

export default function loginReducer(state = {}, action) {
    switch (action.type) {
        case ActionType.RESET_LOADING:
            return {
                ...state,
                inProcess: false
            };
        case ActionType.LOGIN_USER_BEGIN:
            return {
                ...state,
                inProcess: true,
                isLoggedIn: false,
            };
        case ActionType.LOGIN_USER_SUCCESS:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: true,
                email: action.payload.user.UserName,
                languageId: action.payload.user.LanguageId,
                userType: action.payload.user.UserType,
                userId: action.payload.user.UserId,
                firstName: action.payload.user.FirstName,
                lastName: action.payload.user.LastName,
                mobileNumber: action.payload.user.MobileNumber,
                companyName: action.payload.user.CompanyName,
                mainPartnerId: action.payload.user.MainPartnerId,
                affiliateId: action.payload.user.AffiliateId,
                currentUserType: action.payload.user.UserType,
            };
        case ActionType.LOGIN_USER_FAILURE:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: false,
                email: action.payload.user.Username,
                error: action.payload.Error
            };
        case ActionType.USER_TYPE:
            return {
                ...state,
                currentUserType: action.payload,
            };
        case ActionType.REGISTER_USER_BEGIN:
            return {
                ...state,
                inProcess: true,
                isLoggedIn: false,
            };
        case ActionType.REGISTER_USER_SUCCESS:
            return {
                ...state,
                inProcess: false,
                email: action.payload.user.Email,
            };
        case ActionType.REGISTER_USER_FAILURE:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: false,
                error: action.payload.Error
            };

        case ActionType.VERIFY_USER_BEGIN:
            return {
                ...state,
                inProcess: true,
                isLoggedIn: false,
            };
        case ActionType.VERIFY_USER_SUCCESS:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: true,
                email: action.payload.user.UserName,
            };
        case ActionType.VERIFY_USER_FAILURE:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: false,
                error: action.payload.Error
            };
        case ActionType.USER_LOGOUT:
            Auth.invalidateSession();
            window.location.reload();
            return {
                ...state,
                isLoggedIn: false
            };

        default:
            return state;
    }

}




// WEBPACK FOOTER //
// ./src/reducers/LoginReducer.js